import { addMinutes, formatDuration, intervalToDuration } from 'date-fns';

export const shortenDurationString = (duration: string) =>
  duration.replace(/ hours?/, ' hr').replace(/ minutes?/, ' min');

export const minutesToDuration = (minutes: number) => {
  const start = new Date(0);
  const end = addMinutes(start, minutes);

  const duration = intervalToDuration({ start, end });

  return shortenDurationString(
    formatDuration(duration, { format: ['hours', 'minutes'], delimiter: ' ' })
  );
};

export const isDateValid = (date: Date) => !Number.isNaN(date.getTime());
